import React from 'react';
import { Box, Typography } from '@mui/material';
import useCinnamonArtStyles from '../../styles/kozelDarkQuiz/cinnamonArt';
import icon1 from '../../assets/images/kozel_dark_quiz/icon_1.png';
import icon2 from '../../assets/images/kozel_dark_quiz/icon_2.png';
import icon3 from '../../assets/images/kozel_dark_quiz/icon_3.png';
import icon4 from '../../assets/images/kozel_dark_quiz/icon_4.png';

const CinnamonArt = () => {
    const classes = useCinnamonArtStyles();

    return (
        <Box className={classes.container}>
            {/* Title Section */}
            <Box className={classes.titleSection}>
                <Typography variant="h1" className={classes.mainTitle}>
                    FII UN ART ȚAPSTER ADEVĂRAT!
                </Typography>
                <Typography variant="h1" className={classes.subtitle}>
                    PREGĂTEȘTE-ȚI ACASĂ KOZEL CINNAMON
                </Typography>
            </Box>

            {/* Formula Section */}
            <Box className={classes.formulaContainer}>
                {/* Desktop Formula */}
                <Box className={classes.desktopFormula}>
                    <img src={icon1} alt="Kozel Dark" className={classes.beerIcon} />
                    <Typography className={classes.operator}>+</Typography>
                    <img src={icon2} alt="Whipped Cream" className={classes.beerIcon} />
                    <Typography className={classes.operator}>+</Typography>
                    <img src={icon3} alt="Cinnamon" className={classes.beerIcon} />
                    <Typography className={classes.operator}>=</Typography>
                    <img src={icon4} alt="Kozel Cinnamon Art" className={classes.beerIcon} />
                </Box>

                {/* Mobile Formula - Two rows */}
                <Box className={classes.firstRow}>
                    <img src={icon1} alt="Kozel Dark" className={classes.beerIcon} />
                    <Typography className={classes.operator}>+</Typography>
                    <img src={icon2} alt="Whipped Cream" className={classes.beerIcon} />
                    <Typography className={classes.operator}>+</Typography>
                </Box>
                <Box className={classes.secondRow}>
                    <img src={icon3} alt="Cinnamon" className={classes.beerIcon} />
                    <Typography className={classes.operator}>=</Typography>
                    <img src={icon4} alt="Kozel Cinnamon Art" className={classes.beerIcon} />
                </Box>
            </Box>

            {/* Description Section */}
            <Box className={classes.descriptionSection}>
                <Typography className={classes.descriptionText}>
                    Toarnă un Kozel Dark ținut la rece într-o cană curată și umedă.<br />
                    Pune gablonul deasupra cănii și presărează-l cu dragoste și scorțișoară.<br />
                    Voilà! Kozel Cinnamon Art în toată frumusețea ei.<br />
                    Acum ești un adevărat artist. Noroc!
                </Typography>
            </Box>
        </Box>
    );
};

export default CinnamonArt;